import { render } from "./image_modal.vue?vue&type=template&id=38283d12"
import script from "./image_modal.vue?vue&type=script&lang=js"
export * from "./image_modal.vue?vue&type=script&lang=js"

import exportComponent from "/var/deploy/beta/web_head/releases/20260131003634/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__